






















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import {
  DataSourceLoadOptionsBase,
  ProgressStatementsClient,
  ListProgressStatementsForFollowUpQuery,
  ProgressStatementStatus,
  ProgressStatementStatusFilter,
  SetProgressStatementStatusCommand,
} from '@/data/web-api-client';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import BookKeepingNavigation from '@/modules/shared/navigation/BookKeepingNavigation.vue';
import employeesRepository from '@/modules/employees/employeesRepository';

@Component({
  components: {
    Card,
    Datagrid,
    BookKeepingNavigation,
  },
})
export default class ProgressStatementFollowUpOverview extends Vue {
  declare currency: any;

  loading = false;
  totalCount = 0;
  totalAmount = 0;
  toApproveCount = 0;
  toApproveAmount = 0;
  toInvoiceCount = 0;
  toInvoiceAmount = 0;

  employees: any[] = [];

  statusFilterEnum = ProgressStatementStatusFilter;
  statusFilter: ProgressStatementStatusFilter = ProgressStatementStatusFilter.ToApprove;

  private progressStatementsClient = new ProgressStatementsClient(undefined, this.$axios);

  async mounted() {
    await this.loadEmployees();
  }

  public openDetails(e: any) {
    if (e.row && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      const path = `/progressStatements/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`;
      const url = this.$router.resolve(path).href;

      window.open(url, '_blank');
    }
  }

  public async acceptProgressStatements() {
    const selectedRows = this.gridInstance?.getSelectedRowsData();

    if (!selectedRows.length) {
      return;
    }

    if (!confirm('Alle geselecteerde vorderstaten accepteren?')) {
      return;
    }

    this.loading = true;

    try {
      const documentNumbers = selectedRows.map((ps) => ps.documentNumber);
      const status = ProgressStatementStatus.Approved;

      await this.progressStatementsClient.setStatus(
        SetProgressStatementStatusCommand.fromJS({
          status: status,
          documentNumbers: documentNumbers,
        })
      );

      await this.gridInstance.refresh();
      this.gridInstance.clearSelection();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  async loadEmployees() {
    try {
      this.loading = true;
      this.employees = (await employeesRepository.get()).data;
      this.loading = false;
    } catch {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de medewerkers');
    }
  }

  get columns() {
    return [
      {
        cellTemplate: (cellElement: any, cellInfo: any) => {
          const icon = document.createElement('i');

          icon.classList.add('fas', 'fa-briefcase');
          icon.title = `Project ${cellInfo.data.projectName} openen`;

          cellElement.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const route = this.$router.resolve({ path: `/projects/${cellInfo.data.projectId}` });

            if (route?.href) {
              window.open(route.href, '_blank');
            }
          });

          cellElement.classList.add('text-center');
          cellElement.appendChild(icon);
        },
      },
      {
        dataField: 'projectNumber',
        caption: 'Projectnr.',
      },
      {
        dataField: 'projectName',
        caption: 'Projectnaam',
      },
      {
        dataField: 'customer',
        caption: 'Referentie (klant)',
      },
      {
        dataField: 'documentNumber',
        caption: 'Vorderstaatnr.',
      },
      {
        dataField: 'status',
        caption: this.$t('objects.progressStatements.fields.Status'),
        lookup: {
          dataSource: [
            { value: ProgressStatementStatus.Draft, text: 'Klad' },
            { value: ProgressStatementStatus.Open, text: 'Open' },
            { value: ProgressStatementStatus.Send, text: 'Verstuurd' },
            { value: ProgressStatementStatus.Approved, text: 'Aanvaard' },
            { value: ProgressStatementStatus.Declined, text: 'Afgewezen' },
            { value: ProgressStatementStatus.Replaced, text: 'Vervangen' },
            { value: ProgressStatementStatus.Invoiced, text: 'Gefactureerd' },
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        caption: 'Laatste datum verzonden',
        dataField: 'dateSent',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'projectLeader',
        caption: 'Projectleider',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'qualityGuard',
        caption: 'Quality Guard',
        lookup: {
          dataSource: this.employeeSources,
        },
      },
      {
        dataField: 'amount',
        caption: 'Bedrag',
        format: {
          type: 'currency',
          precision: 2,
        },
      },
      {
        type: 'buttons',
        buttons: [
          // {
          //   hint: 'Project progressie',
          //   icon: 'fas fa-tasks',
          //   onClick: (e: any) => {
          //     this.showProjectProgression(e.row.data.projectId);
          //   },
          // },
          {
            hint: 'Vorderstaat openen',
            icon: 'fas fa-share',
            onClick: (e: any) => {
              const route = this.$router.resolve({
                path: `/progressStatements/${e.row.data.documentNumber.replace('/', '-').replace('/', '-')}`,
              });

              if (route?.href) {
                window.open(route.href, '_blank');
              }
            },
          },
        ],
      },
    ];
  }

  get gridInstance(): dxDataGrid {
    return (this.$refs.grid as any).$refs.progressStatementsTable.instance as dxDataGrid;
  }

  get datasource() {
    return new DataSource({
      store: new dxCustomStore({
        key: 'documentNumber',
        load: async (loadOptions) => {
          if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
            loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
          }

          loadOptions.requireTotalCount = true;

          try {
            const result = await this.progressStatementsClient.listForFollowUp(
              new ListProgressStatementsForFollowUpQuery({
                options: DataSourceLoadOptionsBase.fromJS(loadOptions),
                statusFilter: this.statusFilter,
              })
            );

            this.totalCount = result.totalCount!;
            this.totalAmount = result.totalAmount!;
            this.toApproveAmount = result.toApproveAmount ?? 0;
            this.toApproveCount = result.toApproveCount ?? 0;
            this.toInvoiceAmount = result.toInvoiceAmount ?? 0;
            this.toInvoiceCount = result.toInvoiceCount ?? 0;

            return {
              data: result.data,
              totalCount: result.totalCount,
            };
          } catch (error) {
            console.error('Failed to load data:', error);

            return {
              data: [],
              totalCount: 0,
            };
          }
        },
      }),
      paginate: true,
    });
  }

  get employeeSources() {
    return this.employees.map((e) => e.displayName);
  }

  @Watch('statusFilter')
  async onStatusFilterChange(newValue: any, oldValue: any) {
    await this.datasource.reload();
  }
}
